/**
 * example message:
 * {
	"messageType": "alertNotification",
	"notificationId": 1645479377982,
	"notificationDetails": {"updateType":"EXIT_TRIGGERED","notificationType":"TRADE_PLAN_UPDATE","TRADE_PLAN":{"type":"BASIC_TRADING_SYSTEM","id":1,"symbol":"XYZ"}},
	"status": "TACTIC_TRIGGERED",
	"statusDetails": {"pluginTemplate":{"rightDirectionPct":0.2,"retracePct":0.1},"triggerPrice":100.0,"tradeDirection":"LONG","tacticName":"GREEN_TO_RED_POSITIONS","symbol":"XYZ"},
	"date": "2022-02-21T16:36:18.665-0500",
	"timestamp": "1645479378667"
}

 * @param {*} te 
 * @returns object with 2 fields:
 * 1) rightDirectionPct
 * 2) retracePct
 */
export function greenToRedPositionsParser(pluginTemplate) {
  const parsedObject = {
    rightDirectionPct: null,
    retracePct: null,
  };
  if (pluginTemplate) {
    parsedObject.rightDirectionPct = pluginTemplate.rightDirectionPct;
    parsedObject.retracePct = pluginTemplate.retracePct;
  }
  return parsedObject;
}
